import { render, staticRenderFns } from "./UsuarioFornecedorDocumentacaoDialog.vue?vue&type=template&id=37106426&scoped=true"
import script from "./UsuarioFornecedorDocumentacaoDialog.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorDocumentacaoDialog.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFornecedorDocumentacaoDialog.vue?vue&type=style&index=0&id=37106426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37106426",
  null
  
)

export default component.exports